import React, { useState, useEffect } from "react";
import {
    HiPlus,
    HiPencil,
    HiTrash,
    HiEye,
    HiEyeSlash,
    HiXMark,
    HiCheck,
} from "react-icons/hi2";
import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    query,
    orderBy,
    Timestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

export interface WellnessQuestion {
    id: string;
    question: string;
    answers: string[];
    category: string;
    title?: string;
    video?: string;
    active: boolean;
    createdAt?: any;
    updatedAt?: any;
}

export interface QuestionFormData {
    question: string;
    answers: string[];
    category: string;
    title: string;
    video: string;
    active: boolean;
}

class WellnessQAService {

    async fetchWellnessQuestions(): Promise<WellnessQuestion[]> {
        const questionsRef = collection(db, "wellnessQuestions");
        const q = query(questionsRef, orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        return snapshot.docs.map((doc) => {
            const data = doc.data();
            return {
                id: doc.id,
                question: data.question,
                answers: Array.isArray(data.answers) ? data.answers : [],
                category: data.category || "unknown",
                title: data.title,
                video: data.video,
                active: data.active !== undefined ? data.active : true,
                createdAt: data.createdAt,
                updatedAt: data.updatedAt,
            } as WellnessQuestion;
        });
    }
    

}

export const wellnessQAService = new WellnessQAService();